import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { ApiClient } from "~/api/client";

/**
 * Считает просмотр карточки товара: один запрос на id за жизнь страницы.
 *
 * Запрос идёт на /api/client/product/incrementProductViews, оттуда — в
 * nestFarkopDatabase (products.views += 1). Ref-гвард нужен, потому что effect
 * срабатывает и на повторных рендерах с тем же товаром (и дважды в StrictMode),
 * а карточка при переходах между товарами переиспользуется без размонтирования.
 */
export function useProductViewTracking(): void {
  const { product } = useSelector((state: any) => state.product);
  const productId = product?.ID;
  const countedProductIdRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (!productId || countedProductIdRef.current === productId) {
      return;
    }
    countedProductIdRef.current = productId;
    // Ошибка счётчика не должна влиять на карточку — clientApiCall её проглотит
    // и отправит в GlitchTip.
    ApiClient.product.incrementProductViews(productId);
  }, [productId]);
}
